import { Guard, type GuardRun } from '../utils/Guard';
import { stateMe } from '$states/me.svelte';

export class AccessOnboard extends Guard implements GuardRun {
  run() {
    if (
      localStorage.getItem('went_through_circles_onboard_success') === 'true' &&
      !stateMe.onboarding()
    ) {
      return this.cancel();
    }
  }
}
